export const PROVIDER_PORTAL_ROOT = '/demo/technology-solutions/provider-portal';
export const GOVERNANCE_PORTAL_ROOT = '/demo/governance-review';

/** Presentation route classification for the vendor and governance portals. */
export function resolvePortalRoute(
  path: string,
  enabled: boolean,
): 'provider' | 'governance' | 'blocked' | null {
  const clean = path.replace(/\/$/, '');
  if (clean === PROVIDER_PORTAL_ROOT || clean.startsWith(PROVIDER_PORTAL_ROOT + '/'))
    return enabled ? 'provider' : 'blocked';
  if (clean === GOVERNANCE_PORTAL_ROOT || clean.startsWith(GOVERNANCE_PORTAL_ROOT + '/'))
    return enabled ? 'governance' : 'blocked';
  return null;
}
